import React from 'react';
import { Popup, Table } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

const RiskCell = ({ rowValues, entryRecord, index, t }) => {
  // Edge 20+
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;
  const isEdge = !isIE && !!window.StyleMedia;
  let tooltipText = '';

  //Cell style is hardcoded for now...thinking on better solution
  let chemicalRiskColorMap = [
    { risk: '1', color: '#009900' },
    { risk: '2', color: '#ffff66' },
    { risk: '3', color: '#ff6600' },
    { risk: '4', color: '#ff0000' }
  ];
  let envRiskColorMap = [
    { risk: 'ENV_RISK_LEVEL_1_LOW', color: '#92d050' },
    { risk: 'ENV_RISK_LEVEL_2_MEDIUM', color: '#ff8000' },
    { risk: 'ENV_RISK_LEVEL_3_HIGH', color: '#ff0000' }
  ];
  let cellStyle = {};

  if (entryRecord.value === 'CRA_RISK_LEVEL') {
    tooltipText = t('chemical.risk.tooltip');
    let colorVal = chemicalRiskColorMap.find(r => {
      return r.risk === rowValues[entryRecord.key];
    });
    if (colorVal)
      cellStyle = {
        backgroundColor: colorVal.color + (!isEdge ? '4C' : ''), //alpha is set in hexa (4C=30%)
        borderRight: 'solid 5px ' + colorVal.color
      };
  } else if (entryRecord.value === 'ENV_RISK_LEVEL') {
    tooltipText = t('environmental.risk.tooltip');
    let colorVal = envRiskColorMap.find(r => {
      return r.risk === rowValues[entryRecord.key];
    });
    if (colorVal)
      cellStyle = {
        backgroundColor: colorVal.color + (!isEdge ? '4C' : ''),
        borderRight: 'solid 5px ' + colorVal.color
      };
  }

  return (
    <Table.Cell
      key={rowValues.ID + index}
      style={cellStyle}
      className="tableCell tableCellReducedPadding"
    >
      <Popup
        content={tooltipText}
        trigger={
          <span>{rowValues[entryRecord.key] !== 'null' ? t(rowValues[entryRecord.key]) : ''}</span>
        }
      />
    </Table.Cell>
  );
};

export default withTranslation()(RiskCell);
